import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'app-editable-text-warning-dialog',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule],
    templateUrl: './editable-text-warning-dialog.component.html',
    styleUrl: './editable-text-warning-dialog.component.scss'
})
export class EditableTextWarningDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string }) {}
}
